import Dashboard from "../Pages/Students/Dashboard/Dashboard";
import Profile from "../Pages/Profile/Profile";
import SchoolsListing from "../Pages/Common/Schools/SchoolsListing/SchoolsListing";
import ClassesAndCourses from "../Pages/Admin/ClassesAndCourses/ClassesAndCourses";
import CoursesListing from "../Pages/Admin/ClassesAndCourses/CoursesListing/CoursesListing";
import Attendance from "../Pages/Admin/Attendance/Attendance";
import PreviousAttendance from "../Pages/Admin/Attendance/PreviousAttendance/PreviousAttendance";
import ExamListing from "../Pages/Admin/ClassesAndCourses/Exams/ExamListing/ExamListing";
import ExamResult from "../Pages/Admin/Results/ExamResult/ExamResult";
import SportsListing from "../Pages/Common/Sports/SportsListing/SportsListing";
import RoomsListing from "../Pages/Common/Hostel/RoomsListing/RoomsListing";
import TransportsListing from "../Pages/Common/Transports/TransportsListing/TransportsListing";
import HolidaysListing from "../Pages/Common/Holidays/HolidaysListing/HolidaysListing";
import SchoolLibraryListing from "../Pages/Common/SchoolLibrary/SchoolLibraryListing/SchoolLibraryListing";
import { List, Users } from "react-feather";
import AllNotifications from "../Pages/Notifications/AllNotifications/AllNotifications";

export const StudentRoutes = [
  // Student Routes

  // All Notifications
  {
    id: "student_notifications_details",
    path: "/user/student/all-notifications",
    title: "Student Notifications",
    layout: "student",
    parent: false,
    component: <AllNotifications />,
  },
  // Dashboard
  {
    id: "student_dashboard",
    path: "/user/student/dashboard",
    title: "Student Dashboard",
    layout: "student",
    parent: true,
    component: <Dashboard />,
    icon: <List />,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Profile
  {
    id: "student_profile",
    path: "/user/student/profile",
    title: "Student Profile",
    layout: "student",
    parent: false,
    component: <Profile />,
    icon: <Users size={18} />,
  },

  // Schools
  {
    id: "student_schools_listing",
    path: "/user/student/schools",
    title: "Schools",
    layout: "student",
    parent: true,
    component: <SchoolsListing />,
    icon: <i className="fas fa-building"></i>,
    activeIcon: (
      <i className="fas fa-building" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Classes And Courses
  {
    id: "student_classes_courses",
    path: "/user/student/classes",
    title: "Classes And Courses",
    layout: "student",
    parent: true,
    component: <ClassesAndCourses />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "student_courses",
    path: "/user/student/classes/details/*",
    title: "Courses",
    layout: "student",
    parent: false,
    component: <CoursesListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Attendance
  {
    id: "student_attendance_courses",
    path: "/user/student/classes/courses/attendance/:id/:id",
    title: "",
    layout: "student",
    parent: false,
    component: <Attendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "student_attendance_courses",
    path: "/user/student/classes/courses/attendance/details/",
    title: "",
    layout: "student",
    parent: false,
    component: <PreviousAttendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Exams
  {
    id: "student_exams",
    path: "/user/student/classes/:id/courses/:id/exams",
    title: "Exams",
    layout: "student",
    parent: false,
    component: <ExamListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Results
  {
    id: "student_result_view",
    path: "/user/student/classes/:id/courses/:id/exams/:id/result/:id",
    title: "View Result",
    layout: "student",
    parent: false,
    component: <ExamResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Sports
  {
    id: "student_school_sports",
    path: "/user/student/sports",
    title: "Sports",
    layout: "student",
    parent: true,
    component: <SportsListing />,
    icon: <Users size={18} />,
  },

  // Hostel
  {
    id: "student_school_hostel",
    path: "/user/student/hostel",
    title: "Hostel",
    layout: "student",
    parent: true,
    component: <RoomsListing />,
    icon: <i className="fas fa-hotel"></i>,
    activeIcon: <i className="fas fa-hotel" style={{ color: "#ffffff" }}></i>,
  },

  // Transport
  {
    id: "student_school_transport",
    path: "/user/student/transport",
    title: "Transport",
    layout: "student",
    parent: true,
    component: <TransportsListing />,
    icon: <i className="fas fa-bus"></i>,
    activeIcon: <i className="fas fa-bus" style={{ color: "#ffffff" }}></i>,
  },

  // Holidays
  {
    id: "student_school_holidays",
    path: "/user/student/holidays",
    title: "Holidays",
    layout: "student",
    parent: true,
    component: <HolidaysListing />,
    icon: <i className="fas fa-holly-berry"></i>,
    activeIcon: (
      <i className="fas fa-holly-berry" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Library
  {
    id: "student_library_listing",
    path: "/user/student/library",
    title: "Library",
    layout: "student",
    parent: true,
    component: <SchoolLibraryListing />,
    icon: <i className="fas fa-book"></i>,
    activeIcon: <i className="fas fa-book" style={{ color: "#ffffff" }}></i>,
  },
];
